import { render, staticRenderFns } from "./DeleteCart.vue?vue&type=template&id=4a3856d5&scoped=true&"
import script from "./DeleteCart.vue?vue&type=script&lang=js&"
export * from "./DeleteCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3856d5",
  null
  
)

export default component.exports